import { FormSection as Section } from "$components/form-section";
import { TextField } from "$components/rhf-fields";
import { useConfig } from "$global-providers/config-provider/provider";
import { TERRITORY } from "$routes/_lib/constants";
import { useIntl } from "react-intl";
import { PakistanNationalIdInputs } from "../../_lib/pakistan/PakistanNationalIdInputs";
import { CountrySelectInput } from "./CountrySelectInput";
import { KenyaEducationInput } from "./KenyaEducationInput";
import { LanguageSelectInput } from "./LanguageSelectInput";
import { MaritalStatusSelectInput } from "./MaritalStatusSelectInput";

export const AdditionalInformationSection: FC<{
  isChildPatient: boolean;
  showNationalId?: boolean;
  fieldNames: {
    nationality: string;
    maritalStatus: string;
    language: string;
    nationalId: {
      number: string;
      type: string;
      owner: string;
    };
  };
}> = ({ isChildPatient, fieldNames, showNationalId = false }) => {
  const { formatMessage } = useIntl();
  const { territory } = useConfig();

  return (
    <Section
      title={formatMessage({
        id: "patient.additionalInfo.heading",
        defaultMessage: "Additional Information",
      })}
    >
      <CountrySelectInput
        name={fieldNames.nationality}
        label={formatMessage({
          id: "patient.additionalInfo.countrySelect.label",
          defaultMessage: "Nationality",
        })}
        required
      />
      {!isChildPatient && (
        <>
          <LanguageSelectInput name={fieldNames.language} />
          <MaritalStatusSelectInput name={fieldNames.maritalStatus} fullWidth />
          {territory === TERRITORY.KENYA && <KenyaEducationInput />}
          {showNationalId && (
            <>
              {territory === TERRITORY.PAKISTAN ? (
                <PakistanNationalIdInputs
                  fieldNames={{
                    nationalId: fieldNames.nationalId,
                  }}
                />
              ) : (
                <TextField
                  fullWidth
                  name={fieldNames.nationalId.number}
                  label={formatMessage({
                    id: "patient.generalSection.nationalId.label",
                    defaultMessage: "National ID Number",
                  })}
                  placeholder="National ID Number"
                />
              )}
            </>
          )}
        </>
      )}
    </Section>
  );
};
